import { Input } from 'antd';
import { TextAreaProps } from 'antd/lib/input';
import { cx } from 'common/utils/cx';
import { ReactNode } from 'react';

import { Control } from '../Control';

interface Props extends TextAreaProps {
  label?: ReactNode;
  error?: ReactNode;
}

export default ({ label, error, ...bag }: Props) => (
  <Control label={label} error={error}>
    <Input.TextArea
      className={cx({
        'ant-input-warning': error,
      })}
      {...bag}
    />
  </Control>
);
